import script from "./PageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageView.vue?vue&type=script&setup=true&lang=ts"

import "./PageView.vue?vue&type=style&index=0&id=e50eece2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e50eece2"]])

export default __exports__